import { planCollectionNames } from '@smarty-nx/contentful'

export const ADDON_TYPES = {
  CASH: 'CASH',
  DATA: 'DATA',
  EU_DATA_PASS: 'EU_DATA_PASS',
  UK_DATA_PASS: 'UK_DATA_PASS',
}

export const ENDPOINT_STATUSES = {
  STATUS_UNSTARTED: 'STATUS_UNSTARTED',
  STATUS_REQUESTING: 'STATUS_REQUESTING',
  STATUS_SUCCESS: 'STATUS_SUCCESS',
  STATUS_ERROR: 'STATUS_ERROR',
}

export const GROUP_STATUSES = {
  VIEW_ONLY: 'view-only',
  NO_ACCESS: 'no-access',
  SAME_USER: 'same_user',
  CANNOT_INVITE: 'cannot_invite',
  USER_DOES_NOT_EXIST: 'user_does_not_exist',
  EXISTING: 'existing',
}

export const PLAN_SLUGS = {
  UNLIMITED: 'unlimited',
}

export const PLAN_CATEGORIES = {
  DATA_DISCOUNT: 'data-discount',
  NO_DATA_DISCOUNT: 'no-data-discount',

  VOICE_SIM: 'voice-sim',
  DATA_DISCOUNT_SIM: 'data-discount-sim',
  DATA_ONLY_SIM: 'data-only-sim',
  PRELOADED_SIM: 'preloaded-sim',
}

export const PLAN_V3_CATEGORIES = {
  CLASSIC: 'classic', // voice plans previously
  DATA_ONLY: 'data-only',
  DATA_DISCOUNT: 'data-discount',
  RETAIL: 'retail',
  SOCIAL_TARIFF: 'social-tariff',
}

export const PLAN_CATEGORY_LABELS = {
  [PLAN_V3_CATEGORIES.CLASSIC]: 'Rolling Monthly',
  [PLAN_V3_CATEGORIES.DATA_ONLY]: 'Data Only',
  [PLAN_V3_CATEGORIES.DATA_DISCOUNT]: 'Data Discount',
  [PLAN_V3_CATEGORIES.SOCIAL_TARIFF]: 'Social Tariff',
  [PLAN_V3_CATEGORIES.RETAIL]: 'Retail',
}

export const PORTING_CONSTANTS = {
  PAC: 'PAC',
  STAC: 'STAC',
  GET_PAC: 'getPAC',
  GET_STAC: 'getSTAC',
  HAVE_PAC: 'havePAC',
  HAVE_STAC: 'haveSTAC',
}

export const PORT_OUT_STATUSES = {
  PORT_OUT_STATUS_UNKNOWN: 'unknown',
  PORT_OUT_STATUS_UNSTARTED: 'none',
  PORT_OUT_STATUS_PROCESSING: 'requested',
  PORT_OUT_STATUS_READY: 'completed',
  PORT_OUT_STATUS_ERROR: 'error',
}

export const RICH_DATA_STRINGS = {
  FAQ_ITEM_PROP: 'mainEntity',
  FAQ_ITEM_TYPE: 'https://schema.org/FAQPage',
  QUESTION_ITEM_TYPE: 'https://schema.org/Question',
  ANSWER_ITEM_TYPE: 'https://schema.org/Answer',
  ANSWER_ITEM_PROP: 'acceptedAnswer',
  TEXT_ITEM_PROP: 'text',
}

export const CONTENTFUL_TYPES = {
  ADDON_CAROUSEL: 'add-on-carousel',
  DISMISSIBLE_CARD: 'dismissible-card',
}

export const CAROUSEL_TYPES = {
  RECOMMENDED: 'recommended',
  DATA: 'data',
  UK_DATA_PASS: 'uk_data_pass',
  EU_DATA_PASS: 'eu_data_pass',
  OUT_OF_PLAN: 'out_of_plan',
  OUT_OF_PLAN_SECONDARY: 'out_of_plan_secondary',
}

export const VOUCHER_CODE_KEY = 'vc'

export const SWITCHING_INFO =
  'https://help.smarty.co.uk/en/collections/3866305-switching-to-smarty'
export const MAIN_FAQ = 'https://help.smarty.co.uk'
export const WHEN_TO_START_USING_SIM =
  'https://help.smarty.co.uk/en/articles/4227332-when-should-i-start-using-my-sim'
export const PAYPOINT_CONSUMER = 'https://consumer.paypoint.com/'
export const TOPPING_BALANCE =
  'https://help.smarty.co.uk/en/articles/3793308-topping-up-you-account-balance-in-store-via-paypoint'
export const OUR_ADD_ONS =
  'https://help.smarty.co.uk/en/articles/982374-our-add-ons'
export const TERMS_LINK =
  'https://cdn.smarty.co.uk/files/SMARTY-Refer-a-Friend.pdf'
export const TERMS_LINK_UPDATE =
  'https://cdn.smarty.co.uk/files/SMARTY-Refer-a-Friend-T&C-Update.pdf'
export const PRICE_GUIDE =
  'https://cdn.smarty.co.uk/files/SMARTY-Price-Guide.pdf'
export const DEVICE_COMPATIBILITY =
  'https://help.smarty.co.uk/en/articles/11646623-setting-up-and-using-your-esim#h_fbebb0468c'
export const HELP_LEAVING_SMARTY =
  'https://help.smarty.co.uk/en/articles/952726-how-do-i-leave-smarty'
export const HELP_RIGHT_TO_REFUND =
  'https://help.smarty.co.uk/en/articles/7022336-leaving-smarty-right-to-refund'
export const HELP_KEEPING_YOUR_NUMBER =
  'https://help.smarty.co.uk/en/articles/7019273-keeping-your-number'
export const HELP_CANNOT_ACCESS_SIM =
  'https://help.smarty.co.uk/en/articles/4227158-i-can-t-access-my-previous-sim'
export const HELP_PORT_IN_COMPENSATION =
  'https://help.smarty.co.uk/en/articles/6955692-port-in-right-to-compensation'
export const HELP_SWITCHING =
  'https://help.smarty.co.uk/en/collections/3847384-switching'
export const HELP_TRANSFERRING_NUMBER =
  'https://help.smarty.co.uk/en/articles/1062823-transferring-my-number'
export const HELP_LEAVING_NUMBER_BEHIND =
  'https://help.smarty.co.uk/en/articles/7019294-leaving-your-number-behind'
export const HELP_MONEY_BACK_GUARANTEE =
  'https://help.smarty.co.uk/en/articles/4262399-14-day-money-back-guarantee'
export const HELP_GROUPS_SUPPORT =
  'https://help.smarty.co.uk/en/collections/1974243-smarty-groups'
export const HELP_DATA_DISCOUNT =
  'https://help.smarty.co.uk/en/articles/3678775'
export const HELP_SHORTCODES =
  'https://help.smarty.co.uk/en/articles/10364848-a-quick-guide-to-shortcodes'
export const HELP_CHANGE_PLAN =
  'https://help.smarty.co.uk/en/articles/3684794-how-can-i-change-my-plan'
export const HELP_ACCESSIBILITY =
  'https://help.smarty.co.uk/en/articles/967856-accessibility-with-smarty'
export const HELP_TERMS_CONDITIONS =
  'https://help.smarty.co.uk/all-about-smarty/terms-conditions'
export const HELP_SOCIAL_TARIFF_FAQS =
  'https://help.smarty.co.uk/en/articles/6930106-smarty-social-tariff-faqs'
export const HELP_SOCIAL_TARIFF =
  'https://help.smarty.co.uk/en/articles/6867479-smarty-social-tariff'
export const HELP_ACTIVATE_SPARE_SIM =
  'https://help.smarty.co.uk/en/articles/4539514-activating-a-spare-sim-bonus-sim-or-sim-bought-in-a-shop-or-other-online-supplier'
export const HELP_MARITIME_NETWORKS =
  'https://help.smarty.co.uk/en/articles/16119183-using-your-sim-at-sea-maritime-usage-explained'

export const COMMUNITY_SITE = 'https://community.smarty.co.uk'

export const SAME_ORIGIN_REFERER_MINIMUM_HISTORY_LENGTH = 3

export const PLAN_COLLECTION_TAGS: Record<string, string> = {
  [planCollectionNames.VOICE_PLANS]: 'Rolling Monthly',
  [planCollectionNames.MONEY_BACK_PLANS]: 'Money Back',
  [planCollectionNames.DATA_ONLY_PLANS]: 'Data Only',
}

export const CHIP_TEXTS = {
  GROUP_DISCOUNT: 'GROUP DISCOUNT',
}

export const FAMILY_PLAN_SIMS_NUMBER_KEY = 'familyPlanSimsNumber'

export const MAX_FAMILY_PLAN_MEMBERS = 8

export enum SIM_JOURNEY_TYPES {
  SIM_IN_HAND_JOURNEY = 'sim_in_hand_journey',
  ONLINE_SIM_ORDER_JOURNEY = 'online_sim_order_journey',
}

export const MAX_ACTIVE_GROUP_MEMBERS_NUMBER = 7
export const MIN_ACTIVE_GROUP_MEMBERS_NUMBER = 2
